const generateCaptcha = (content) => {
    // Set up the CAPTCHA question and correct answer
    const captchaQuestion = "Enter 'admin' ";
    const correctAnswer = "admin";

    // Prompt the user for input
    const userAnswer = prompt(`${content} ${captchaQuestion}`);

    // Ensure the user's input is trimmed and checked for case sensitivity
    if (userAnswer && userAnswer.trim().toLowerCase() === correctAnswer.toLowerCase()) {
        return true;
    } else {
        return false;
    }
};

module.exports = generateCaptcha;
